// extracted by mini-css-extract-plugin
export default {"liStyle":"userInfoItem_liStyle__0y2Cz","item":"userInfoItem_item__TUYFN","data":"userInfoItem_data__IL6KI"};